// extracted by mini-css-extract-plugin
export var tosLink = "_3v-0";